module.exports = __webpack_public_path__ + "img/beauty_wrinkle-remover.e08ae26.svg";